import React from 'react';
import {
	Routes,
	Route
  } from 'react-router-dom';
  import Moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showNotif, cleanNotif } from "../../../../jsx/actions/notifAction"

import MapPAYGO from '../adminModule/Menu/paygUserMap_OpenStreetMap';
import UserProfile from '../paygoUser/Menu/userprofile.jsx';
import UserRepayment from '../adminModule/Menu/paygUserRepayment.jsx';

import UserDetails from '../adminModule/Menu/paygUserDetails'
import BoxManagement from './Menu/boxmanagement.jsx';
import EnterCode from './Menu/enterSuperAdminValidationCode.jsx';
import SupressUserError from './Menu/supressUserManagement.jsx';
import Config from './Menu/config.jsx';
import Financial from './Menu/financial.jsx';
import SmsManagement from './Menu/smsManagement.jsx';
import Account from './Menu/accountlist.jsx'; 
    
//    DataEnergy from './container/data_energy_only.jsx',
//    DataEnergySolar from './container/data_energy_solar.jsx',
import Production from './Menu/energy_data_views.jsx';
import Consommation from './Menu/consommation.jsx';

import Page from '../commonModules/layouts/Page';

function SuperAdminMainContent(props){

    return (
			<div>
				      <Routes>
              <Route  path="userrepayment" element={<Page><UserRepayment {...props} /></Page>} />
              <Route  path="paygomap" element={<Page><MapPAYGO {...props} /></Page>} />
              <Route  path="userdetails" element={<Page><Config {...props} /></Page>} />
              <Route  path="smsmanagement" element={<Page><SmsManagement {...props} /></Page>} />
              <Route  path="financial" element={<Page><Financial {...props} /></Page>} />
              <Route  path="account" element={<Page><Account {...props} /></Page>} />
              <Route  path="userprofile" element={<Page><UserProfile {...props} /></Page>} />
              <Route  path="boxmanagement" element={<Page><BoxManagement {...props} /></Page>} />
              <Route  path="suppress" element={<Page><SupressUserError {...props} /></Page>} />
					  	<Route  path="userdetails" element={<Page><UserDetails {...props} /></Page>} />
					  	<Route  path="entercode" element={<Page><EnterCode/></Page>} />
					  	<Route  path="production" element={<Production
							agg="pt1hour"
							timeFrom= {Moment().add(-10, 'days').utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
							timeTo = {Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
							ChartName = {'Consommation Journalière'}
							sensor= {'panel,load current,panel power,system yield,battery voltage'}
							graphName = {'Consommation par jour des 10 derniers jours'}
							{...props} 
						/>} />
					  	<Route  path="consumption" element={<Consommation
							tokenUser= {props.tokenUser}
							agg="pt1hour"
							timeFrom= {Moment().add(-6, 'months').utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
							timeTo = {Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
							ChartName = {'Consommation Journalière'}
							sensor= {""}
							graphName = {'Consommation par jour des 6 derniers mois'}
							{...props} 
						/>} />
					    </Routes>
			</div>
		);
};

function mapStateToProps(state){
  return {
		downloading: state.extract.fetching,
		SHOW_NOTIF: state.notif.show,
		MESSAGE: state.notif.message,
		TYPE: state.notif.type,
  }
}

function mapDispatchToProps(dispatch){  
	return bindActionCreators({
		showNotif,
		cleanNotif,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminMainContent);
